import React from 'react';
import ScrollToTop from '../components/ScrollToTop';
import CustomerFeedback from '../components/CustomerFeedback';

const Reviews = () => {
  return (
    <article>
      <ScrollToTop />
      <CustomerFeedback limit={100} />
    </article>
  );
};

export default Reviews;
